/*@flow*/
import { createPortal } from 'react-dom';

export default (element: ?React$Element<any>, node: ?HTMLElement): any | null => {
  if (!node || !element) {
    return null;
  }
  return createPortal(element, node);
};
